<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="close" v-on:click="close()"></div>
      <div class="modalContent">
        <div class="videoCnt comingSoon" v-if="!d.media[lang]">
          Coming Soon
        </div>
        <div class="videoCnt" v-else-if="d.media[lang].mimetype === 'video/youtube'">
          <iframe :src="`https://www.youtube.com/embed/${d.media[lang].ytVideoId}?autoplay=1`"
            frameborder="0" allowfullscreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
        </div>
        <div class="videoCnt" v-else>
          <VuePlyr ref="video" :options="{ hideControls: false }">
            <video></video>
          </VuePlyr>
        </div>
        <div class="videoInfo">
          <h4>{{d.title[lang]}}</h4>
          <template v-if="d.descriptions[lang]">
            <h5>Sinopsis:</h5>
            <p v-html="d.descriptions[lang]"></p>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  name: 'videoDialog',
  components: { VuePlyr },
  data() {
    return {
      show: false,
      d: null,

      lang: 'id',
      langCode: 'id-id',
    };
  },
  methods: {
    open(d, name) {
      this.show = true;
      this.d = d;
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      // const src = [];
      // src.push({ src: `https://storage.googleapis.com/deepdivedigitaldeveloper.appspot.com/${video}`, type: 'video/mp4', size: 1080 });
      // // if (video.vid1080p) src.push({ src: video.vid1080p, type: 'video/mp4', size: 1080 });
      // // if (video.vid720p) src.push({ src: video.vid720p, type: 'video/mp4', size: 720 });
      // // if (video.vid480p) src.push({ src: video.vid480p, type: 'video/mp4', size: 480 });
      // // if (video.vid360p) src.push({ src: video.vid360p, type: 'video/mp4', size: 360 });
      // setTimeout(() => {
      //   const v = this.$refs.video.player;
      //   v.source = { type: 'video', title: name, sources: src };
      //   v.play();
      // });
    },
    close() {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      background-color: #eee;
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .close{
      width: 46px; height: 46px;
      // border-radius: 50%;
      position: absolute;
      right: 20px; top: 20px;
      background-image: url(../assets/close.png);
      background-color: #ddd;
      background-size: 18px auto;
      border-radius: 50%;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 91;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        // background-image: url(../assets/close-white.png);
        background-color: #ccc;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
    }
    .modalContent{
      z-index: 2;
      overflow: auto;
      box-sizing: border-box;
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      z-index: 7;
      .videoCnt{
        width: 100%;
        height: 40vw;
        background-color: #000;
        &.comingSoon{
          color: #999;
          font-size: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #d5d5d5;
          font-weight: 600;
        }
        @media (max-width: 1024px) {
          height: 50vw;
        }
        @media (max-width: 640px) {
          height: 76vw;
        }
        iframe{
          width: 100%; height: 100%;
          display: block;
        }
      }
      .videoInfo{
        max-width: 860px;
        margin: 0 auto;
        padding: 30px 0 40px;
        @media (max-width: 940px) {
          max-width: none;
          margin: 0 30px;
        }
        @media (max-width: 640px) {
          margin: 0 20px;
        }
        h4{
          font-size: 36px;
          margin: 0 0 10px;
          padding: 0 0 4px;
          border-bottom: #ccc 1px solid;
          @media (max-width: 640px) {
            font-size: 24px;
          }
        }
        h5{
          margin: 0 0 10px;
          font-size: 22px;
          @media (max-width: 640px) {
            font-size: 20px;
          }
        }
        p{
          font-size: 18px;
          margin: 0 0 16px;
          line-height: 1.3;
          white-space: pre-line;
          @media (max-width: 640px) {
            font-size: 17px;
          }
        }
      }
    }
  }
</style>
